import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Location } from '../models/location.model';
import { BaseService } from '../../../shared/services/base.service';
import { PaginableResponseModel } from '../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../shared/models/singleResponse.model';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class LocationsService extends BaseService<Location, Location> {
  private fullUrl = `${environment.apiUrl}/api/v2/booking/merchant-locations`;

  constructor(http: HttpClient) {
    super(http, '/api/v2/booking/merchant-locations');
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.fullUrl);
  }

  getList(filter: any): Observable<PaginableResponseModel<Location>> {
    return this.http.post<PaginableResponseModel<Location>>(
      `${this.fullUrl}/list`,
      filter
    );
  }

  getByMerchant(merchantId: string): Observable<SingleResponseModel<Location[]>> {
    return this.http.get<SingleResponseModel<Location[]>>(
      `${this.fullUrl}/merchant/${merchantId}`
    );
  }

  getLocationByUid(uid: string): Observable<SingleResponseModel<Location>> {
    return this.http.get<SingleResponseModel<Location>>(
      `${this.fullUrl}/${uid}`
    );
  }

  updateWithPayload(uid: string, payload: any): Observable<any> {
    return this.http.put<any>(`${this.fullUrl}/${uid}`, payload);
  }

  getDeleteImpact(uid: string): Observable<SingleResponseModel<LocationDeleteImpact>> {
    return this.http.get<SingleResponseModel<LocationDeleteImpact>>(
      `${this.fullUrl}/${uid}/delete-impact`
    );
  }

  delete(uid: string): Observable<SingleResponseModel<LocationDeleteResult>> {
    return this.http.delete<SingleResponseModel<LocationDeleteResult>>(
      `${this.fullUrl}/${uid}`
    );
  }

  getAdminPanelLink(locationId: string): Observable<{ url: string }> {
    return this.http.get<{ url: string }>(`${environment.apiUrl}/api/v2/booking/admin-panel-link?locationId=${encodeURIComponent(locationId)}`);
  }
}

export interface LocationDeleteImpact {
  locationId: string;
  locationName: string;
  isMainLocation: boolean;
  activeBookingsCount: number;
}

export interface LocationDeleteResult {
  locationId: string;
  cancelledBookingsCount: number;
}
